import { RFQBuyerModelConverter, RFQBuyerModel, ApiModel } from '@steelbuy/ts-shared';
import { usePaginatedQuery } from '../../utils/usePaginatedQuery';

export const MY_RFQ_KEY = 'quotes';

const modelConverter = new RFQBuyerModelConverter();
const searchListingMapFn = (data: RFQBuyerModel) =>
    modelConverter.toViewModel(data as unknown as ApiModel<RFQBuyerModel>);

export const useMyRFQs = ({
    filterCriteria,
    pageSize,
    referenceNumber,
}: {
    filterCriteria?: Record<string, string>;
    pageSize: number;
    referenceNumber?: string;
}) => {
    let filter;
    if (filterCriteria || referenceNumber) {
        filter = {
            ...(filterCriteria || undefined),
            ...(referenceNumber ? { quoteReferenceNumber: referenceNumber } : undefined),
        };
    }
    return usePaginatedQuery<RFQBuyerModel>({
        url: '/api/buyer/quotes',
        requestOptions: {
            filter,
            pageSize,
        },
        mapFn: searchListingMapFn,
        queryKey: [MY_RFQ_KEY, filterCriteria, referenceNumber],
        queryOptions: {
            refetchOnMount: false,
        },
    });
};
